import { HTTP } from "@/utils/http-common"
import { isNil } from "lodash"
export default {
  list: function($, search = null, filters = {}, orders = {}, paginate = {}) {
    return new Promise((resolve, reject) => {
      const params = {
        ordering: orders,
        search: search,
        page: paginate.page || 1,
        page_size: paginate.page_size || 10
      }
      HTTP.get(
        `/perfumist/back-office/products/${params ? "?" : ""}${Object.keys(
          params
        )
          .filter(key => !isNil(params[key]))
          .map(key => key + "=" + params[key])
          .join("&")}&${filters}`
      )
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },
  getProductsKPI: function($, search = null, filters = {}) {
    return new Promise((resolve, reject) => {
      const params = {
        search: search,
      }
      HTTP.get(
        `/perfumist/back-office/products/kpi/${params ? "?" : ""}${Object.keys(params)
          .filter(key => !isNil(params[key]))
          .map(key => key + "=" + params[key])
          .join("&")}&${filters}`
      )
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  }
}
